import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FiAlertTriangle, FiCheckCircle } from 'react-icons/fi';
import { BOUTON_SECONDAIRE } from './organigrammeOutils';
import InvitationPortail from './InvitationPortail';

/**
 * L'avertissement « n'a pas de compte Portail » des aperçus de l'organigramme
 * (#469 T2, T3), avec de quoi agir (Yros/Kavero#470) : « Inviter » crée le
 * compte du responsable et l'invite ; l'avertissement devient une
 * confirmation. Inviter n'écrit rien dans l'organigramme : l'aperçu attend
 * toujours « Confirmer ».
 */
function SansComptePortail({ personne }) {
  const { t } = useTranslation();
  const [ouvert, setOuvert] = useState(false);
  const [invite, setInvite] = useState(false);

  if (invite) {
    return (
      <p className="mt-2 flex items-start gap-1 text-green-700">
        <FiCheckCircle className="mt-0.5 shrink-0" aria-hidden="true" />
        <span>{t('comptePortail.invite', { nom: personne.nom })}</span>
      </p>
    );
  }
  return (
    <div className="mt-2">
      <p className="flex items-start gap-1 text-amber-700">
        <FiAlertTriangle className="mt-0.5 shrink-0" aria-hidden="true" />
        <span>{t('organigramme.sansComptePortail', { nom: personne.nom })}</span>
      </p>
      {!ouvert && (
        <button type="button" className={`${BOUTON_SECONDAIRE} ml-4 mt-1 py-1`} onClick={() => setOuvert(true)}>
          {t('comptePortail.inviter')}
        </button>
      )}
      {ouvert && (
        <InvitationPortail employeId={personne.id} onInvite={() => setInvite(true)}
          onAnnuler={() => setOuvert(false)} />
      )}
    </div>
  );
}

export default SansComptePortail;
